import {useMemo} from 'react'
import {useMsal} from '@azure/msal-react'
import {UserRole} from '@common/models'

import {getUserRoles} from '~/utils/simulateJWT'

type NavigationType = {
  useCombinedNav: boolean
  usePartnerAdminNav: boolean
  isPractitionerOnly: boolean
}

export const useNavigationType = (): NavigationType => {
  const {accounts} = useMsal()

  const jwtClaims = accounts[0]?.idTokenClaims as
    | Record<string, string>
    | undefined
  const roles = getUserRoles(jwtClaims)

  const isPractitioner = useMemo(
    () => roles.split(',').includes(UserRole.PRACTITIONER),
    [roles],
  )

  const isPartnerAdministrator = useMemo(
    () => roles.split(',').includes(UserRole.PARTNER_ADMINISTRATOR),
    [roles],
  )

  const hasBothRoles = isPractitioner && isPartnerAdministrator

  return {
    useCombinedNav: hasBothRoles,
    usePartnerAdminNav: isPartnerAdministrator && !hasBothRoles,
    isPractitionerOnly: isPractitioner && !isPartnerAdministrator,
  }
}
